import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output,
} from '@angular/core';
import { TrackByValue } from '@app/shared/types';
import { IDropdownMenuOption } from '@app/shared/types/ui';
import { DropdownBaseComponent } from '@geniuspos/ui-shared/modules/xdm-shared-components/base-component/dropdown/dropdown-base.component';

@Component({
  selector: 'base-array-string-renderer-menu',
  templateUrl: './base-array-string-renderer-menu.component.html',
  styleUrls: ['./base-array-string-renderer-menu.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BaseArrayStringRendererMenuComponent extends DropdownBaseComponent {
  @Input() public options: IDropdownMenuOption[];
  @Input() public wrapperClass: string = '';
  @Input() public trackByValue: TrackByValue;
  @Output() public dropdownMenuClick: EventEmitter<{
    option: IDropdownMenuOption;
  }> = new EventEmitter<{ option: IDropdownMenuOption }>();

  public clickDropdownMenu(option: IDropdownMenuOption): void {
    this.dropdownMenuClick.emit({ option });
  }

  public getClickable(): boolean {
    return this.dropdownMenuClick.observers.length > 0;
  }
}
